module.exports = __webpack_public_path__ + "img/Open_Knowledge_Foundation_Deutschland_Logo.2f6be44a.svg";